import React from "react";
import { useTranslation } from "react-i18next";
export default function MakeUp() {
  const { t, i18n } = useTranslation();
  return <div>MakeUp</div>;
}
